/**
 * ConfigurationFilterBar Component
 *
 * Search input and filter dropdowns for filtering configurations.
 */

var React = require('react');
var {
  ENVIRONMENT_FILTER_OPTIONS,
  STATUS_FILTER_OPTIONS,
} = require('./RemoteConfigurations.types');

/**
 * ConfigurationFilterBar component
 * @param {Object} props
 * @param {Object} props.filters - Current filter state
 * @param {Function} props.onFilterChange - Called when filters change
 */
var ConfigurationFilterBar = function (props) {
  var filters = props.filters;
  var onFilterChange = props.onFilterChange;

  var handleSearchChange = function (e) {
    if (onFilterChange) {
      onFilterChange({
        search: e.target.value,
        environment: filters.environment,
        status: filters.status,
      });
    }
  };

  var handleEnvironmentChange = function (e) {
    if (onFilterChange) {
      onFilterChange({
        search: filters.search,
        environment: e.target.value,
        status: filters.status,
      });
    }
  };

  var handleStatusChange = function (e) {
    if (onFilterChange) {
      onFilterChange({
        search: filters.search,
        environment: filters.environment,
        status: e.target.value,
      });
    }
  };

  return React.createElement(
    'div',
    {
      className: 'remote-config-filter-bar',
    },
    [
      // Search input
      React.createElement(
        'div',
        {
          key: 'search',
          className: 'remote-config-search',
        },
        [
          // Search icon
          React.createElement(
            'div',
            {
              key: 'icon',
              className: 'remote-config-search__icon',
            },
            React.createElement(
              'svg',
              {
                width: 18,
                height: 18,
                viewBox: '0 0 24 24',
                fill: 'none',
                stroke: 'currentColor',
                strokeWidth: 2,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
              },
              [
                React.createElement('circle', {
                  key: 'circle',
                  cx: 11,
                  cy: 11,
                  r: 8,
                }),
                React.createElement('line', {
                  key: 'line',
                  x1: 21,
                  y1: 21,
                  x2: 16.65,
                  y2: 16.65,
                }),
              ],
            ),
          ),
          // Search input
          React.createElement('input', {
            key: 'input',
            type: 'text',
            className: 'remote-config-search__input',
            placeholder: 'Search configurations...',
            value: filters.search,
            onChange: handleSearchChange,
          }),
        ],
      ),

      // Environment filter
      React.createElement(
        'select',
        {
          key: 'environment',
          className: 'remote-config-filter-select',
          value: filters.environment,
          onChange: handleEnvironmentChange,
        },
        ENVIRONMENT_FILTER_OPTIONS.map(function (option) {
          return React.createElement(
            'option',
            {
              key: option.value,
              value: option.value,
            },
            option.label,
          );
        }),
      ),

      // Status filter
      React.createElement(
        'select',
        {
          key: 'status',
          className: 'remote-config-filter-select',
          value: filters.status,
          onChange: handleStatusChange,
        },
        STATUS_FILTER_OPTIONS.map(function (option) {
          return React.createElement(
            'option',
            {
              key: option.value,
              value: option.value,
            },
            option.label,
          );
        }),
      ),
    ],
  );
};

module.exports = ConfigurationFilterBar;
